import React from 'react'
import resources from '../../../services'
import DataTable from '../../../composents/DataTable'
import MainPage from '../../../composents/MainPage'
import { renderStatus, renderStyle } from '../../DashBoard'

const title = 'Water Market'
const headers = {
  icon: 'feather icon-droplet',
  title: title,
  description: 'Sell and buy your water safely.',
}

export default function WaterMarketPage() {
  return (
    <MainPage headers={headers} show_search={false}>
      <DataTable
        column={[
          {
            label: 'Seller',
            field: 'status',
            renderStyle: (e) => {
              return e?.type === 'sell' ? e.user?.surname : e?.person?.surname
            },
          },
          { label: 'Quantity', field: 'quantity' },
          {
            label: 'Amount',
            field: 'amount',
          },

          {
            label: 'Type',
            field: 'status',
            renderStyle: (data) => {
              return renderStyle(data)
            },
          },

          {
            label: 'Buyer',
            field: 'status',
            renderStyle: (e) => {
              return e?.type === 'buy' ? e.user?.surname : ''
            },
          },
          {
            label: 'Status',
            field: 'status',
            renderStyle: (data) => {
              return renderStatus(data)
            },
          },
        ]}
        resource={resources.transaction}
        title={title}
        show_btn={false}
        deleteItem={false}
        update={false}
        link="/hydrowallet/water_market"
      />
    </MainPage>
  )
}
